import React, { useEffect, useRef, useState } from "react";
import FloatTitleCard from "../../cards/floatTitleCard";
import { useSelector } from "react-redux";
import axios from "axios";
import serverConfig from "../../../utilities/serverConfig.json";
import apiConfig from "../../../utilities/apiConfig.json";
import { toast } from "react-toastify";

const RepeatVisitModal = ({ id, currentTotalVisitAmount, updateTurns }) => {

  const { token, roles } = useSelector((state) => state.user);
  const tokenLocal = localStorage.getItem("token");
  const headers = { Authorization: "Bearer " + (token ? token : tokenLocal) };

  const [loading, setLoading] = useState(false);
  const [totalVisitAmount, setTotalVisitAmount] = useState(currentTotalVisitAmount);
  const repeatModal = useRef(null)
  const closeModalBtn = useRef(null)
  const [description, setDescription] = useState();

  const changeEventStatusAPI = () => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url + apiConfig.api.updateAPIs.updateEvent + id,
        {
          total_visit_amount: totalVisitAmount,
          description,
          status: 'done'
        },
        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          updateTurns(id)
          closeModalBtn?.current?.click()
        } else {
          if (typeof response.data.errors === "string") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error.message);
      });
  };

  useEffect(() => {
    setTotalVisitAmount(currentTotalVisitAmount);
  }, [currentTotalVisitAmount, id]);

  useEffect(() => {
    if (repeatModal?.current) {
      repeatModal.current.addEventListener('hidden.bs.modal', () => {
        setTotalVisitAmount(currentTotalVisitAmount ?? '')
      })
    }
  }, [repeatModal, currentTotalVisitAmount])

  return (
    <div
      className="modal fade"
      id="repeatVisitModal"
      ref={repeatModal}
      tabIndex="-1"
      aria-labelledby="repeatVisitModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="repeatVisitModalLabel">
              مشخصات نوبت
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="بستن"
            ></button>
          </div>
          <div className="modal-body">
            <span>مشخصات نوبت پذیرش شده را وارد کنید.</span>
            <FloatTitleCard title={"هزینه پرداخت شده توسط بیمار"} error={false}>
              <div className="positoin-relative">
                <input
                  type="text"
                  value={totalVisitAmount?.toLocaleString('fa')}
                  onChange={(e) => setTotalVisitAmount(e.target.value)}
                  className="form-control border-0"
                />
                <span style={{ left: '20px', top: '40%', height: '100%', position: 'absolute' }} className="">تومان</span>
              </div>
            </FloatTitleCard>
            <FloatTitleCard title={"توضیحات منشی برای نوبت"} error={false}>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="form-control"
              />
            </FloatTitleCard>
          </div>
          <div className="modal-footer">
            <button
              ref={closeModalBtn}
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              بازگشت
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={changeEventStatusAPI}
              disabled={loading}
            >
              {loading ? "در حال ثبت..." : "ثبت"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RepeatVisitModal;
